import { FC, useCallback, useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { CustomCheckboxField } from '../../../custom-check-box-field';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export interface HideNonAnalyzedCallsFilterTrayProps {
  disabled?: boolean;
  nonAnalyzedCallsCount?: number;
}

export const HideNonAnalyzedCallsFilterTray: FC<HideNonAnalyzedCallsFilterTrayProps> = ({
  nonAnalyzedCallsCount = 0,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified } = useCallIntelFiltersContext();

  const onChange = useCallback(
    (value: boolean) => {
      updateFilterValues({ hideNonAnalyzedCalls: value });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ hideNonAnalyzedCalls: !!filterValues.hideNonAnalyzedCalls });
  }, [filterValues.hideNonAnalyzedCalls, updateFilterModified]);

  return (
    <FilterTraySection label={t('Hide Calls')} showClear={false}>
      <CustomCheckboxField
        label={t('Hide calls with no analysis ({{count}})', { count: nonAnalyzedCallsCount })}
        name='toggle-analyzed-calls'
        onChange={onChange}
        value={filterValues.hideNonAnalyzedCalls}
        trackingId={trackingIds.callIntel.hideNonAnalyzedCallsFilter}
      />
    </FilterTraySection>
  );
};
